import './CampaignDetails.css';

function CampaignDetails({ campaign }) {
  const heroLabel = campaign.campaign_type === 'discount'
    ? 'Diskaun Anda'
    : campaign.campaign_type === 'cashback'
    ? 'Cashback Anda'
    : 'Hadiah Anda';

  const heroText = campaign.campaign_type === 'discount'
    ? `${campaign.discount_percentage}% OFF`
    : campaign.campaign_type === 'cashback'
    ? `RM ${parseFloat(campaign.cashback_amount || 0).toFixed(2)}`
    : campaign.reward_title || 'Hadiah Eksklusif';

  const slotsUsed = campaign.registration_limit - campaign.available_slots;
  const slotsPercentage = campaign.registration_limit > 0
    ? Math.round((slotsUsed / campaign.registration_limit) * 100)
    : 0;

  return (
    <div className="campaign-details animate-fade-in-up">
      <div className="campaign-header">
        <span className="campaign-badge">{campaign.campaign_type}</span>
        <h1 className="campaign-title">{campaign.name}</h1>
      </div>

      {campaign.image_url && (
        <div className="campaign-image animate-fade-in-up stagger-1">
          <img src={campaign.image_url} alt={campaign.name} className="campaign-banner-img" />
        </div>
      )}

      <div className="hero-banner animate-fade-in-up stagger-1">
        <span className="hero-label">{heroLabel}</span>
        <h2 className="hero-value">{heroText}</h2>
      </div>

      {campaign.description && (
        <div
          className="campaign-description animate-fade-in-up stagger-2"
          dangerouslySetInnerHTML={{ __html: campaign.description }}
        />
      )}

      <div className="info-grid animate-fade-in-up stagger-2">
        <div className="info-cell">
          <span className="info-label">Mula</span>
          <span className="info-value">
            {new Date(campaign.start_date).toLocaleDateString('ms-MY')}
          </span>
        </div>
        <div className="info-cell">
          <span className="info-label">Tamat</span>
          <span className="info-value">
            {new Date(campaign.end_date).toLocaleDateString('ms-MY')}
          </span>
        </div>
      </div>

      <div className="slots-section animate-fade-in-up stagger-3">
        <div className="slots-header">
          <span className="slots-label">Slot Tersedia</span>
          <span className="slots-count">{campaign.available_slots} lagi</span>
        </div>
        <div className="slots-bar">
          <div className="slots-fill" style={{ width: `${slotsPercentage}%` }} />
        </div>
        <span className="slots-detail">
          {slotsUsed} daripada {campaign.registration_limit} dituntut
        </span>
      </div>

      {campaign.rules && campaign.rules.length > 0 && (
        <div className="rules-section animate-fade-in-up stagger-4">
          <h3 className="rules-title">Terma & Syarat</h3>
          <ul className="rules-list">
            {campaign.rules.map((rule, idx) => (
              <li key={idx}>{rule}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default CampaignDetails;
